import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';
import { quizDataDefault } from 'utils/valueDefault';

const apiUrl = `${API_URL}/quiz`;

export const ACTION_TYPES = {
  FETCH_QUIZ_LIST: 'quiz/FETCH_QUIZ_LIST',
  FETCH_QUIZ: 'quiz/FETCH_QUIZ',
  CREATE_QUIZ: 'quiz/CREATE_QUIZ',
  UPDATE_QUIZ: 'quiz/UPDATE_QUIZ',
  DELETE_QUIZ: 'quiz/DELETE_QUIZ',
  UPDATE_CHOICE: 'quiz/UPDATE_CHOICE',
  ADD_CHOICE: 'quiz/ADD_CHOICE',
  REMOVE_CHOICE: 'quiz/REMOVE_CHOICE',
  PREVIEW_SELECT_CHOICE: 'quiz/PREVIEW_SELECT_CHOICE',
  PREVIEW_RESET_CHOICE: 'quiz/PREVIEW_RESET_CHOICE',
  RESET: 'quiz/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  previewAnswer: [],
  entities: [], //ent
  entity: quizDataDefault, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const quizReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_QUIZ_LIST):
    case REQUEST(ACTION_TYPES.FETCH_QUIZ):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_QUIZ):
    case REQUEST(ACTION_TYPES.UPDATE_QUIZ):
    case REQUEST(ACTION_TYPES.DELETE_QUIZ):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_QUIZ_LIST):
    case FAILURE(ACTION_TYPES.FETCH_QUIZ):
    case FAILURE(ACTION_TYPES.CREATE_QUIZ):
    case FAILURE(ACTION_TYPES.UPDATE_QUIZ):
    case FAILURE(ACTION_TYPES.DELETE_QUIZ):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload.response,
      };
    case SUCCESS(ACTION_TYPES.FETCH_QUIZ_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_QUIZ):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_QUIZ):
    case SUCCESS(ACTION_TYPES.UPDATE_QUIZ):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
        successMessage: action.payload.meta,
      };
    case SUCCESS(ACTION_TYPES.DELETE_QUIZ):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
    case ACTION_TYPES.PREVIEW_SELECT_CHOICE: {
      if (state.previewAnswer.filter(f => f.id === action.payload.id) < 1) {
        return {
          ...state,
          previewAnswer: [...state.previewAnswer, action.payload],
        };
      } else {
        return {
          ...state,
          previewAnswer: state.previewAnswer.map(p => {
            if (p.id === action.payload.id) {
              return {
                ...p,
                answer: action.payload.answer,
              };
            } else {
              return p;
            }
          }),
        };
      }
    }
    case ACTION_TYPES.PREVIEW_RESET_CHOICE: {
      return {
        ...state,
        previewAnswer: [],
      };
    }
    case ACTION_TYPES.REMOVE_CHOICE: {
      let id = action.payload.id;
      let question = state.entity.question_list.elements.filter(f => f.id !== id);
      let answer = state.entity.answer_list.elements.filter(f => f.id !== id);
      return {
        ...state,
        entity: {
          ...state.entity,
          answer_list: {
            elements: [...answer],
          },
          question_list: {
            elements: [...question],
          },
        },
      };
    }
    case ACTION_TYPES.ADD_CHOICE: {
      let answerElement = action.payload.answer;
      let questionElement = action.payload.question;
      return {
        ...state,
        entity: {
          ...state.entity,
          answer_list: {
            elements: [...state.entity.answer_list.elements, ...answerElement],
          },
          question_list: {
            elements: [...state.entity.question_list.elements, ...questionElement],
          },
        },
      };
    }
    case ACTION_TYPES.UPDATE_CHOICE: {
      let answerElement = action.payload.answer;
      let questionElement = action.payload.question;
      // return state;
      let newQ = state.entity.question_list.elements.map(q => {
        if (q.id === questionElement[0].id) {
          return {
            ...q,
            ...questionElement[0],
          };
        } else {
          return q;
        }
      });
      let newA = state.entity.answer_list.elements.map(a => {
        if (a.id === answerElement[0].id) {
          return { ...a, ...answerElement[0] };
        } else {
          return a;
        }
      });
      return {
        ...state,
        entity: {
          ...state.entity,
          question_list: {
            elements: newQ,
          },
          answer_list: {
            elements: newA,
          },
        },
      };
    }
    default:
      return state;
  }
};

export default quizReducer;

// ACTIONS

export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_QUIZ_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntitiesCondition = (condition, page, sort) => ({
  type: ACTION_TYPES.FETCH_QUIZ_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition}`, {
    params: {
      page: undefined || page,
      sort: undefined || sort
    },
  })
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_QUIZ,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_QUIZ,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const updateEntity = (entity, id) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_QUIZ,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  return result;
};

export const deleteEntity = (id, pagination, pencarian, condition, sortTable) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_QUIZ,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { successMessage: `Berhasil hapus!` },
  });
  if(pencarian === true){
    let condition2 = "name:"+condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, sortTable));
  }else{
    dispatch(getEntities(pagination.current-1, null, sortTable));
  }
  
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});

export const updateChoice = payload => ({
  type: ACTION_TYPES.UPDATE_CHOICE,
  payload,
});

// add entry to `question_list` & `answer_list`
export const addChoice = payload => ({
  type: ACTION_TYPES.ADD_CHOICE,
  payload,
});

export const removeChoice = payload => ({
  type: ACTION_TYPES.REMOVE_CHOICE,
  payload,
});

export const previewSelectChoice = payload => ({
  type: ACTION_TYPES.PREVIEW_SELECT_CHOICE,
  payload,
});

export const previewResetChoice = () => ({
  type: ACTION_TYPES.PREVIEW_RESET_CHOICE,
});
